import { render } from "./SearchDashboard.vue?vue&type=template&id=7e8f6809"
import script from "./SearchDashboard.vue?vue&type=script&lang=js"
export * from "./SearchDashboard.vue?vue&type=script&lang=js"

import "./SearchDashboard.vue?vue&type=style&index=0&id=7e8f6809&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__